import { useState } from 'react';
import { LinkableEntityType } from '@api';
import { Button, Group, Modal, Select, Stack } from '@mantine/core';
import { useTranslation } from 'react-i18next';

const TRANS_KEY = 'EDIT_VENUE_OPERATOR_MODAL';

type EditVenueOperatorModalPropsType = {
  opened: boolean;
  onClose: () => void;
  onSave: (operatorId: string) => void;
  availableOperators: LinkableEntityType[];
  currentOperatorId: string | null;
  isPending: boolean;
};

export const EditVenueOperatorModal: React.FC<
  EditVenueOperatorModalPropsType
> = ({
  opened,
  onClose,
  onSave,
  availableOperators,
  currentOperatorId,
  isPending,
}) => {
  const { t } = useTranslation('venueDetailsGeneral');

  const [selectedOperator, setSelectedOperator] = useState(currentOperatorId);

  const operatorOptions = availableOperators.map((operator) => ({
    label: operator.name,
    value: operator.id,
  }));

  const handleSave = () => {
    if (!selectedOperator) return;
    onSave(selectedOperator);
  };

  return (
    <Modal opened={opened} onClose={onClose} title={t(`${TRANS_KEY}.TITLE`)}>
      <Stack>
        <Select
          data={operatorOptions}
          required
          searchable
          placeholder={t(`${TRANS_KEY}.OPERATOR_PLACEHOLDER`)}
          value={selectedOperator}
          onChange={setSelectedOperator}
        />
        <Group justify="end">
          <Button variant="outline" onClick={onClose} color="blue">
            {t('CANCEL_BUTTON', { ns: 'common' })}
          </Button>
          <Button
            type="submit"
            color="blue"
            disabled={!selectedOperator}
            onClick={handleSave}
            loading={isPending}
          >
            {t('SAVE_BUTTON', { ns: 'common' })}
          </Button>
        </Group>
      </Stack>
    </Modal>
  );
};
